import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-grievance-action',
  templateUrl: './grievance-action.component.html',
  styleUrls: ['./grievance-action.component.scss']
})
export class GrievanceActionComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  actionForm: FormGroup;
  session: any;
  statusList: any;
  filterstatusList: any;
  submitpayload: any;
  GrievanceData: any;
  grivenceData;
  submitButton = true;
  constructor(public umsService: UmsService,private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private dialogRef2:MatDialogRef<GrievanceActionComponent>,
  ) { }
  InstuName
  actionFormArray;
  ngOnInit(): void {
    this.submitButton = true;
    const state = history.state;
    this.grivenceData = state.data;
    if (!this.grivenceData) {
      this.grivenceData = JSON.parse(localStorage.getItem('grivenceData') || '{}');
    }
    this.fetchStatus();
    this.getSecretData();
    this.loadsettingspage();
    this.actionForm = this.fb.group({
      StatusCode: new FormControl ('', [Validators.required]),
      ActionDetails: new FormControl ('', [Validators.required]),
      CommentText: new FormControl ('', [Validators.required]),
    });
  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.hide();
      this.InstuName = res.projectPharam['InstituteName']
      this.session = res.projectPharam['SnName']
    })
  }
  fetchStatus() {
    const payload = {};
    payload['CdType'] = 'GS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.statusList = res.data;
        this.filterstatusList = this.statusList.slice();
      } else {
      }
    });
  }

  Save(){
    if (this.actionForm.invalid) {
      this.actionForm.get('StatusCode').markAsTouched();
      this.actionForm.get('ActionDetails').markAsTouched();
      this.actionForm.get('CommentText').markAsTouched();
      // this.actionForm.get('Publish').markAsTouched();
       this.SubmitFormarkAsTouched();
      return;
    } else {
      this.ADDAction();
    }
  }

  ADDAction() {
    this.submitpayload = this.actionForm.value;
    let payload = {}
    payload['StatusCode'] = this.submitpayload.StatusCode
    payload['ActionDetails'] = this.submitpayload.ActionDetails
    payload['GrievanceID'] = this.grivenceData.GrievanceID
    payload['ActionTakenByUserID'] = sessionStorage.getItem('userId')
    this.umsService.addAction(payload).subscribe(res => {
      this.submitButton = false;
      this.ADDComment();
    },
  );
  }

  ADDComment() {
    if (this.actionForm.invalid) {
      // this.SubmitFormarkAsTouched();
    } else {
      this.submitpayload = this.actionForm.value;
      let payload = {}
      payload['CommentText'] = this.submitpayload.CommentText
      payload['GrievanceID'] = this.grivenceData.GrievanceID
      payload['Publish'] = this.submitpayload.Publish
      payload['CommentedByUserID'] = sessionStorage.getItem('userId')
      this.umsService.addComment(payload).subscribe(res => {
        this.submitButton = false;
        if(res.status){
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef2.close();
          });
        }
        else{
        }
      },
    );
    }
   
  }

  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Grievance';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.actionForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.actionForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            if (element.FormPattern == '') {
              this.actionForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.actionForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.actionFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  SubmitFormarkAsTouched() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Grievance';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired)
            // Object.keys(this.actionForm.controls).forEach((controlName) => {
            //   const control = this.actionForm.get(controlName);
            //   if (control) {
            //     control.markAsTouched();  // Mark the control as touched
            //     control.updateValueAndValidity(); // Update the control's validation status
            //   }
            // });
             {
            const control = this.actionForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
            }
          }
        }
      });
      this.actionFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  onOptionChange(event: Event): void {
    const selectedOption = (event.target as HTMLInputElement).value;
  }

  checkformandatory(actionForm: FormGroup): boolean {
    let checkPublish = actionForm.get('Publish')?.touched && actionForm.get('Publish')?.errors?.required;
    return checkPublish;
}
}
